
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import NotPaidCustomer from "../components/unpaidcustomer";
import Footer from "../components/footer";

function NotPaidCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <NotPaidCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default NotPaidCustomerPage;
